import superagent from "superagent"

// const platformHost = "http://localhost:8080";
const platformHost = "https://platform.deixaqueeuprocuro.com.br"

const requestPostWithoutAuth = (path, body) => {
    return superagent
        .post(`${platformHost}${path}`)
        .send(body)
        .set("Content-Type", "application/json")
        .then((res) => res)
        .catch((err) => err);
}

const requestPost = (path, body) => {
    return superagent
        .post(`${platformHost}${path}`)
        .send(body)
        .set("Content-Type", "application/json")
        .set("authorization", localStorage.getItem("jwt"))
        .then((res) => res)
        .catch((err) => {
            if (err.status === 401) {
                localStorage.clear();
                return window.location.href = "/";
            }
            console.debug(err);
            throw err
        });
}

const requestPatch = (path, body) => {
    console.log(path, body);
    return superagent
        .patch(`${platformHost}${path}`)
        .send(body)
        .set("Content-Type", "application/json")
        .set("authorization", localStorage.getItem("jwt"))
        .then((res) => res)
        .catch((err) => err);
};

const requestPut = (path, body) => {
    return superagent
        .put(`${platformHost}${path}`)
        .send(body)
        .set("Content-Type", "application/json")
        .set("authorization", localStorage.getItem("jwt"))
}

const requestPutWithoutAuth = (path, body) => {
    return superagent
        .put(`${platformHost}${path}`)
        .send(body)
        .set("Content-Type", "application/json")
}

const requestGet = (path) => {
    return superagent
        .get(`${platformHost}${path}`)
        .set("Content-Type", "application/json")
        .set("Authorization", localStorage.getItem("jwt"))
        .then((res) => res)
        .catch((err) => {
            if (err.status === 401) {
                localStorage.clear();
                window.location.href = "/";
            } else {
                return err
            }
        })
}

const requestGetWithoutAuth = (path) => {
    return superagent
        .get(`${platformHost}${path}`)
        .set("Content-Type", "application/json")
}

const requestDelete = (path) => {
    return superagent
        .delete(`${platformHost}${path}`)
        .set("Content-Type", "application/json")
        .set("Authorization", localStorage.getItem("jwt"))
        .then((res) => res)
        .catch((err) => {
            if (err.status === 401) {
                localStorage.clear();
                window.location.href = "/";
            }
        })
}

const PlatformRequest = {
    loginRequest: (body) => requestPostWithoutAuth(`/v1/auth/login`, body),
    resetPasswordRequest: (body) => requestPostWithoutAuth(`/v1/auth/reset`, body),
    validateToken: (token) => requestGetWithoutAuth(`/v1/auth/reset/${token}/validate`),
    updatePassword: (body) => requestPutWithoutAuth(`/v1/auth/reset`, body),
    getAuthProvider: () => requestGet(`/v1/providers/auth`),

    noHasPart: (searchId) => requestDelete(`/v1/searchs/${searchId}/part`),
    providerHasPart: (searchId) => requestGet(`/v1/searchs/${searchId}/provider/part-found`),
    hasPart: (searchId, body) => requestPut(`/v2/searches/${searchId}/part-found`, body),
    getSearches: (page, size) => requestGet(`/v2/searches/provider?page=${page}&size=${size}`),
    getSearch: (id) => requestGet(`/v1/searchs/${id}`),
    getSearchesPartFound: (page, size) => requestGet(`/v2/searches/provider/part-found?page=${page}&size=${size}`),
    getResumeProvider: (daysAgo) => requestGet(`/v2/searches/resume?daysAgo=${daysAgo}`),

    getProviderExist: (ssn) => requestGet(`/v1/providers/${ssn}/exist`),
    createProvider: (body) => requestPostWithoutAuth(`/v1/providers`, body),
    updateProvider: (id, body) => requestPut(`/v1/providers/${id}`, body),

    getAuthEmployee: () => requestGet(`/v1/employees/logged`),
    getProviderEmployee: () => requestGet(`/v1/employees/auth-provider`),
    createEmployee: (body) => requestPost(`/v1/employees/`, body),
    lockUnlockEmployee: (id, body) => requestPatch(`/v1/employees/${id}/block`, body),
    deleteEmployee: (id) => requestDelete(`/v1/employees/${id}`),

    getSegments: () => requestGetWithoutAuth(`/v1/searchs/segments`),
    getBrands: () => requestGetWithoutAuth(`/v1/searchs/brands`)


}

export default PlatformRequest;
